

<template>
	<div class="hotspot-mobile" v-bind:data-index="index">
		<a @click="onClick" class="link d-block py-2 mb-2 px-4">
			<slot></slot>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';
import { mapState } from 'vuex';

export default {
	props: ['hotspot', 'index'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('navigation', ['current']),
	},
	methods: {
		onClick( event ) {
			EventBus.$emit('hotspot-clicked', this.createEventParameters( event ) );
		},
		createEventParameters( event ) {
			return Object.assign({
				hotspot: this.hotspot,
				link: this.hotspot.link,
				$el: this.$el,
				originalEvent: event,
			});
		}
	}

}
</script>

<style scoped lang="scss">
		
	.hotspot-mobile {
		.link {
			color: #fff;
			background: rgba(#fff, 0.2);
			letter-spacing: 0.02em;
			transition: 0.2s all;
			user-select: none;
			font-weight: 600;
		}
		h6 {
			font: 1.6rem/1.4 $font-sans;
			font-weight: 400;
		}
		&.current .link {
			background-color: rgba(#fff, 0.3);
		}
	}

</style>
